import { cloneDeep } from 'lodash';
import { menuRouteArr, constantRoutes } from '@/router';

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      const menuList = JSON.parse(localStorage.getItem("menuList"));
      const authRoute = JSON.parse(localStorage.getItem("authRoute")); // 这个权限已经不用了，如果要重启，查看git提交记录找之前的代码吧ε=(´ο｀*)))
      const CB_PERMISSION = JSON.parse(localStorage.getItem("CB_PERMISSION"));
      const CP_PERMISSION = JSON.parse(localStorage.getItem("CP_PERMISSION")) || [];
      const SAAS_MERCHANT = JSON.parse(localStorage.getItem("SAAS_MERCHANT")) || 0;
      let accessedRoutes = cloneDeep(menuRouteArr) || [];
      /**
       * 设置新的路由隐藏
       * 2022年8月23日16:03:33
       * */
      if (menuList && menuList.length > 0) {
        const menuPathList = menuList.map(i => i.menuPath);
        accessedRoutes = accessedRoutes.reduce((arr, item) => {
          if (item.hidden) {
            if (menuPathList.includes(item.path)) item.hidden = false;
          }
          arr.push(item);
          return arr;
        }, []);
      }
      // copilot begin
      // 辅助函数：根据权限设置隐藏状态
      const setHiddenBasedOnPermission = (route, permissionValue) => {
        const index = accessedRoutes.findIndex(i => i.path === route);
        if (index !== -1) accessedRoutes[index].hidden = !permissionValue;
      };
      const setChildrenHiddenBasedOnPermission = (baseIndex, path, permissionValue) => {
        const index = accessedRoutes[baseIndex].children.findIndex(i => i.path === path);
        if (index !== -1) accessedRoutes[baseIndex].children[index].hidden = !permissionValue;
      };

      // 收款单展示隐藏逻辑
      setHiddenBasedOnPermission('/collection-bill', CB_PERMISSION !== -1019);

      // 云管家菜单展示隐藏逻辑，serviceType：1-分账服务，2-同名转账
      setHiddenBasedOnPermission('/cloud-manage', CP_PERMISSION.length > 0);

      // 云管家子菜单展示隐藏逻辑，serviceType：1-分账服务，2-同名转账
      const cloudManageIndex = accessedRoutes.findIndex(i => i.path === '/cloud-manage');
      if (!accessedRoutes[cloudManageIndex].hidden) {
        setChildrenHiddenBasedOnPermission(cloudManageIndex, 'enterprise-same-name-transfer', CP_PERMISSION.includes(2));
        setChildrenHiddenBasedOnPermission(cloudManageIndex, 'split-account', CP_PERMISSION.includes(1));
      }
      if (SAAS_MERCHANT === 1) { // 只展示云管家菜单
        accessedRoutes = accessedRoutes.map((i) => {
          if (i.path !== '/cloud-manage') i.hidden = true;
          return i;
        });
      }
      // copilot end
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
